import { render } from "./Interests.vue?vue&type=template&id=2955643a"
import script from "./Interests.vue?vue&type=script&lang=js"
export * from "./Interests.vue?vue&type=script&lang=js"
script.render = render

export default script